/* src/app/system-utils/side-panel/side-panel.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
}
.panel-list-root {
  display: flex;
  flex-direction: row;
  height: 100%;
  border: solid 1px var(--tem-border);
  color: var(--tem-ink);
  border-radius: 4px;
  position: relative;
  overflow-y: auto;
}
.panel-list {
  display: flex;
  flex-direction: column;
  min-width: 200px;
  height: 100%;
  width: 30%;
  border-right: solid 1px var(--tem-border);
  position: relative;
  overflow: auto;
  direction: rtl;
}
.panel-list-item {
  padding: 20px 10px;
  border-bottom: solid 1px var(--tem-border);
  position: relative;
  font-weight: 500;
  cursor: pointer;
}
.item-selected {
  background-color: color-mix(in srgb, var(--tem-deep) 12%, transparent);
  width: 3px;
  height: 100%;
  right: 0;
  position: absolute;
  top: 0px;
}
.panel-list-item-wrapper-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.panel-list-item-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 10px;
  border-radius: 16px;
  padding: 10px;
  overflow: auto;
  border: solid 1px var(--tem-border);
}
.title-panel {
  width: 100%;
  font-size: large;
  font-weight: 500;
  margin-bottom: 6px;
}
.info {
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  padding: 15px;
  font-weight: 500;
  text-align: center;
  background-color: var(--tem-accent-soft);
}
.button-panel-list {
  width: 100%;
  height: 40px;
  margin-top: 4px;
}
.panel-elevated {
  box-shadow: var(--tem-shadow, 0 2px 8px rgba(0, 0, 0, 0.08));
}
.panel-divider {
  margin: 6px 0;
}
actions-buttons {
  display: flex;
  flex-direction: column;
}
/*# sourceMappingURL=side-panel.component.css.map */
